import { combineReducers } from 'redux'
import squares from './squares'

const store = combineReducers({
  squares
})

export default store